

import { Dispatch } from "redux";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { UserLogin, UserLoginWithTwoFactor } from 'api/user'
import { getFirebaseBackend } from "helpers/firebase_helper";

import { logout } from "./reducer";//loginError, loginSuccess, logoutSuccess


interface User {
    username: string;
    password: string;
    twoFactorCode: string;
    sessionToken: string;
}
interface LoginThunkArgs {
    user: User;
    history: any; // Adjust the type as per your router library
}


export const userLoginThunk = createAsyncThunk(
    'login',
    async (user: User) => {
        const res = await UserLogin({
            username: user.username,
            password: user.password

        });
        if (res?.data)
            res.data.username = user.username;
        return res;
    },
);
export const userLoginChallengeThunk = createAsyncThunk(
    'login-challenge',
    async (user: User, thunkAPI) => {
        try {
            const res = await UserLoginWithTwoFactor({
                username: user.username,
                twoFactorCode: user.twoFactorCode
            });

            return res;
        } catch (error) {
            thunkAPI.rejectWithValue(error)
        }
    },
);

/* 
export const loginUserThunk = (
  user: User,
  history: any
): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch: Dispatch) => {
  try {
      let response: any;
       if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
 
             response = await postFakeLogin({
                 email: user.email,
                 password: user.password,
             });
 
             localStorage.setItem("authUser", JSON.stringify(response));
 
         }  
      else if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
          let fireBaseBackend = await getFirebaseBackend();

          response = await fireBaseBackend.loginUser(
              user.email,
              user.password
          )
      }

      if (response) {
          dispatch(loginSuccess(response));
          history("/dashboard");
      }
  } catch (error) {

      dispatch(loginError(error));
  }
}; */

export const logoutUser = () => async (dispatch: Dispatch) => {
    try {
        // localStorage.removeItem("authUser");
        dispatch(logout());

        if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
            let fireBaseBackend = await getFirebaseBackend();

            const response = fireBaseBackend.logout;
            //dispatch(logoutSuccess(response));
        } else {
            // dispatch(logoutSuccess(true));
        }
    } catch (error) {
        //  dispatch(loginError(error));
    }
}


export const socialLogin = (type: any, history: any) => async (dispatch: any) => {
    try {
        let response: any;

        if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
            const fireBaseBackend = getFirebaseBackend();
            response = fireBaseBackend.socialLoginUser(type);
        }

        const socialData = await response;

        if (socialData) {
            // sessionStorage.setItem("authUser", JSON.stringify(socialData));
            //  dispatch(loginSuccess(socialData));
            history('/dashboard');
        }

    } catch (error) {
        // dispatch(loginError(error));
    }
}